import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "menu-contenido",
  "aria-label": "Menú principal"
}
const _hoisted_2 = { class: "menu-superior" }
const _hoisted_3 = {
  key: 0,
  class: "usuario-card"
}
const _hoisted_4 = {
  class: "usuario-avatar",
  "aria-hidden": "true"
}
const _hoisted_5 = { class: "usuario-info" }
const _hoisted_6 = { class: "usuario-nombre" }
const _hoisted_7 = { class: "usuario-rol" }
const _hoisted_8 = { class: "menu" }
const _hoisted_9 = {
  key: 0,
  class: "opciones"
}
const _hoisted_10 = {
  key: 1,
  class: "opciones"
}
const _hoisted_11 = {
  key: 2,
  class: "seccion-titulo"
}
const _hoisted_12 = {
  key: 3,
  class: "opciones"
}
const _hoisted_13 = {
  key: 4,
  class: "opciones"
}
const _hoisted_14 = {
  key: 5,
  class: "opciones"
}
const _hoisted_15 = {
  key: 6,
  class: "seccion-titulo"
}
const _hoisted_16 = {
  key: 7,
  class: "opciones"
}
const _hoisted_17 = {
  key: 8,
  class: "opciones"
}
const _hoisted_18 = {
  key: 9,
  class: "seccion-titulo"
}
const _hoisted_19 = {
  key: 10,
  class: "opciones"
}
const _hoisted_20 = {
  key: 11,
  class: "opciones"
}
const _hoisted_21 = {
  key: 12,
  class: "seccion-titulo"
}
const _hoisted_22 = {
  key: 13,
  class: "opciones"
}
const _hoisted_23 = {
  key: 14,
  class: "opciones"
}
const _hoisted_24 = { class: "salir" }

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import router from '@/router'
import useAutenticar from '@/store/IngresoAutenticar'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppMenu',
  setup(__props) {

/**
 * Menú lateral de navegación.
 *
 * Filtra sus ítems por los permisos del usuario. Es filtrado de PRESENTACIÓN: no
 * autoriza nada, solo evita ofrecer pantallas que devolverían 403.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const route = useRoute()
const store = useAutenticar()

const iniciales = computed(() => {
  const nombre = store.usuarioActual?.name ?? ''
  return nombre
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(p => p[0].toUpperCase())
    .join('')
})

const rolPrincipal = computed(() =>
  store.usuarioActual?.roles?.[0]?.label ?? store.usuarioActual?.roles?.[0]?.name ?? 'Sin rol'
)

const seccionGestion = computed(() =>
  store.tienePermiso('modelos.ver') ||
  store.tienePermiso('indicadores.ver') ||
  store.tienePermiso('procesos.ver') ||
  store.tienePermiso('evidencias.subir')
)

const seccionEvaluacion = computed(() =>
  store.tienePermiso('rubricas.ver') ||
  store.tienePermiso('calificacion.calificar') ||
  store.tienePermiso('expertos.ver')
)

function isActive(menu: string) {
  if (route.meta.menu) {
    return route.meta.menu === menu
  }

  if (menu === 'gestion-modelo' && !route.query.modo) return true
  if (menu === 'gestion-indicadores' && route.query.modo === 'indicadores') return true
  if (menu === 'gestion-instrumentos' && route.query.modo === 'calificar instrumento') return true
  if (menu === 'gestion-rubricas' && route.meta.menu === 'gestion-rubricas') return true
  if (menu === 'asignar-evaluadores' && (route.meta.menu === 'asignar-evaluadores' || route.query.modo === 'asignar-evaluadores')) return true
  if (menu === 'evaluacion-expertos' && (route.meta.menu === 'evaluacion-expertos' || route.query.modo === 'evaluacion-expertos')) return true
  if (menu === 'gestion-evidencias' && route.meta.menu === 'gestion-evidencias') return true
  if (menu === 'proceso-autoevaluacion' && route.meta.menu === 'proceso-autoevaluacion') return true
  if (menu === 'gestion-areas' && route.meta.menu === 'gestion-areas') return true
  if (menu === 'gestion-usuarios' && route.meta.menu === 'gestion-usuarios') return true

  return false
}

const Logout = async () => {
  await store.Logout()
  router.push({ name: 'Ingreso' })
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(store).usuarioActual)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(iniciales.value), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(store).usuarioActual.name), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(rolPrincipal.value), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _cache[11] || (_cache[11] = _createElementVNode("hr", { class: "divider" }, null, -1)),
      _createElementVNode("div", _hoisted_8, [
        (_unref(store).tienePermiso('dashboard.ver'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
              _createVNode(_component_router_link, {
                to: { name: 'Dashboard' },
                class: _normalizeClass({ 'active-link': _unref(route).name === 'Dashboard' }),
                "aria-current": _unref(route).name === 'Dashboard' ? 'page' : undefined
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("svg", {
                    class: "icono",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("rect", {
                      x: "3",
                      y: "3",
                      width: "7",
                      height: "9"
                    }),
                    _createElementVNode("rect", {
                      x: "14",
                      y: "3",
                      width: "7",
                      height: "5"
                    }),
                    _createElementVNode("rect", {
                      x: "14",
                      y: "12",
                      width: "7",
                      height: "9"
                    }),
                    _createElementVNode("rect", {
                      x: "3",
                      y: "16",
                      width: "7",
                      height: "5"
                    })
                  ], -1),
                  _createElementVNode("span", null, "Dashboard", -1)
                ])),
                _: 1,
                __: [0]
              }, 8, ["class", "aria-current"])
            ]))
          : _createCommentVNode("", true),
        (_unref(store).tienePermiso('calendario.ver'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
              _createVNode(_component_router_link, {
                to: { name: 'Calendario' },
                class: _normalizeClass({ 'active-link': _unref(route).name === 'Calendario' }),
                "aria-current": _unref(route).name === 'Calendario' ? 'page' : undefined
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("svg", {
                    class: "icono",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("rect", {
                      x: "3",
                      y: "4",
                      width: "18",
                      height: "18",
                      rx: "2"
                    }),
                    _createElementVNode("line", {
                      x1: "16",
                      y1: "2",
                      x2: "16",
                      y2: "6"
                    }),
                    _createElementVNode("line", {
                      x1: "8",
                      y1: "2",
                      x2: "8",
                      y2: "6"
                    }),
                    _createElementVNode("line", {
                      x1: "3",
                      y1: "10",
                      x2: "21",
                      y2: "10"
                    })
                  ], -1),
                  _createElementVNode("span", null, "Calendario", -1)
                ])),
                _: 1,
                __: [1]
              }, 8, ["class", "aria-current"])
            ]))
          : _createCommentVNode("", true),
        (seccionGestion.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Gestión"))
          : _createCommentVNode("", true),
        (_unref(store).tienePermiso('modelos.ver'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
              _createVNode(_component_router_link, {
                to: { name: 'ListaVersiones' },
                class: _normalizeClass({ 'active-link': isActive('gestion-modelo') }),
                "aria-current": isActive('gestion-modelo') ? 'page' : undefined
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createElementVNode("svg", {
                    class: "icono",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" }),
                    _createElementVNode("path", { d: "m3.3 7 8.7 5 8.7-5" }),
                    _createElementVNode("path", { d: "M12 22V12" })
                  ], -1),
                  _createElementVNode("span", null, "Gestión de Modelo", -1)
                ])),
                _: 1,
                __: [2]
              }, 8, ["class", "aria-current"])
            ]))
          : _createCommentVNode("", true),
        (_unref(store).tienePermiso('indicadores.ver'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
              _createVNode(_component_router_link, {
                to: { name: 'ListaVersiones', query: { modo: 'indicadores' } },
                class: _normalizeClass({ 'active-link': isActive('gestion-indicadores') }),
                "aria-current": isActive('gestion-indicadores') ? 'page' : undefined
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("svg", {
                    class: "icono",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M3 3v18h18" }),
                    _createElementVNode("path", { d: "M18 17V9" }),
                    _createElementVNode("path", { d: "M13 17V5" }),
                    _createElementVNode("path", { d: "M8 17v-3" })
                  ], -1),
                  _createElementVNode("span", null, "Gestión de Indicadores", -1)
                ])),
                _: 1,
                __: [3]
              }, 8, ["class", "aria-current"])
            ]))
          : _createCommentVNode("", true),
        (_unref(store).tienePermiso('procesos.ver'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
              _createVNode(_component_router_link, {
                to: _unref(store).tienePermiso('procesos.crear') ? { name: 'ProcesoAutoevaluacion' } : { name: 'ProcesoAutoevaluacionUsuario' },
                class: _normalizeClass({ 'active-link': isActive('proceso-autoevaluacion') }),
                "aria-current": isActive('proceso-autoevaluacion') ? 'page' : undefined
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createElementVNode("svg", {
                    class: "icono",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8" }),
                    _createElementVNode("path", { d: "M21 3v5h-5" })
                  ], -1),
                  _createElementVNode("span", null, "Proceso de Autoevaluación", -1)
                ])),
                _: 1,
                __: [4]
              }, 8, ["to", "class", "aria-current"])
            ]))
          : _createCommentVNode("", true),
        (seccionEvaluacion.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Evaluación"))
          : _createCommentVNode("", true),
        (_unref(store).tienePermiso('rubricas.ver'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
              _createVNode(_component_router_link, {
                to: { name: 'GestionRubricas' },
                class: _normalizeClass({ 'active-link': isActive('gestion-rubricas') }),
                "aria-current": isActive('gestion-rubricas') ? 'page' : undefined
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createElementVNode("svg", {
                    class: "icono",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M9 12h6" }),
                    _createElementVNode("path", { d: "M9 16h6" }),
                    _createElementVNode("path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }),
                    _createElementVNode("path", { d: "M6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z" })
                  ], -1),
                  _createElementVNode("span", null, "Gestión de Rúbricas", -1)
                ])),
                _: 1,
                __: [5]
              }, 8, ["class", "aria-current"])
            ]))
          : _createCommentVNode("", true),
        (_unref(store).tienePermiso('expertos.ver'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
              _createVNode(_component_router_link, {
                to: { name: 'ListaVersiones', query: { modo: 'evaluacion-expertos' } },
                class: _normalizeClass({ 'active-link': isActive('evaluacion-expertos') }),
                "aria-current": isActive('evaluacion-expertos') ? 'page' : undefined
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("svg", {
                    class: "icono",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "m9 11 3 3L22 4" }),
                    _createElementVNode("path", { d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" })
                  ], -1),
                  _createElementVNode("span", null, "Evaluación por Expertos", -1)
                ])),
                _: 1,
                __: [6]
              }, 8, ["class", "aria-current"])
            ]))
          : _createCommentVNode("", true),
        (_unref(store).tienePermiso('campus.ver'))
          ? (_openBlock(), _createElementBlock("p", _hoisted_18, "Organización"))
          : _createCommentVNode("", true),
        (_unref(store).tienePermiso('campus.ver'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
              _createVNode(_component_router_link, {
                to: { name: 'GestionAreas' },
                class: _normalizeClass({ 'active-link': isActive('gestion-areas') }),
                "aria-current": isActive('gestion-areas') ? 'page' : undefined
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createElementVNode("svg", {
                    class: "icono",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M3 21h18" }),
                    _createElementVNode("path", { d: "M5 21V7l8-4v18" }),
                    _createElementVNode("path", { d: "M19 21V11l-6-4" }),
                    _createElementVNode("path", { d: "M9 9v.01" }),
                    _createElementVNode("path", { d: "M9 12v.01" }),
                    _createElementVNode("path", { d: "M9 15v.01" }),
                    _createElementVNode("path", { d: "M9 18v.01" })
                  ], -1),
                  _createElementVNode("span", null, "Estructura Organizacional", -1)
                ])),
                _: 1,
                __: [7]
              }, 8, ["class", "aria-current"])
            ]))
          : _createCommentVNode("", true),
        (_unref(store).tienePermiso('campus.ver'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
              _createVNode(_component_router_link, {
                to: { name: 'TableroProgramas' },
                class: _normalizeClass({ 'active-link': isActive('tablero-programas') }),
                "aria-current": isActive('tablero-programas') ? 'page' : undefined
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createElementVNode("svg", {
                    class: "icono",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("rect", {
                      x: "3",
                      y: "3",
                      width: "7",
                      height: "9"
                    }),
                    _createElementVNode("rect", {
                      x: "14",
                      y: "3",
                      width: "7",
                      height: "5"
                    }),
                    _createElementVNode("rect", {
                      x: "14",
                      y: "12",
                      width: "7",
                      height: "9"
                    }),
                    _createElementVNode("rect", {
                      x: "3",
                      y: "16",
                      width: "7",
                      height: "5"
                    })
                  ], -1),
                  _createElementVNode("span", null, "Tablero de Programas", -1)
                ])),
                _: 1,
                __: [8]
              }, 8, ["class", "aria-current"])
            ]))
          : _createCommentVNode("", true),
        (_unref(store).tienePermiso('usuarios.ver') || _unref(store).tienePermiso('usuarios.crear'))
          ? (_openBlock(), _createElementBlock("p", _hoisted_21, "Administración"))
          : _createCommentVNode("", true),
        (_unref(store).tienePermiso('usuarios.ver') || _unref(store).tienePermiso('usuarios.crear'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
              _createVNode(_component_router_link, {
                to: { name: 'AsignarRoles' },
                class: _normalizeClass({ 'active-link': isActive('gestion-usuarios') }),
                "aria-current": isActive('gestion-usuarios') ? 'page' : undefined
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createElementVNode("svg", {
                    class: "icono",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }),
                    _createElementVNode("circle", {
                      cx: "9",
                      cy: "7",
                      r: "4"
                    }),
                    _createElementVNode("path", { d: "M22 21v-2a4 4 0 0 0-3-3.87" }),
                    _createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
                  ], -1),
                  _createElementVNode("span", null, "Gestión de Usuarios", -1)
                ])),
                _: 1,
                __: [9]
              }, 8, ["class", "aria-current"])
            ]))
          : _createCommentVNode("", true),
        (_unref(store).tienePermiso('trazabilidad.ver'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
              _createVNode(_component_router_link, {
                to: { name: 'Trazabilidad' },
                class: _normalizeClass({ 'active-link': isActive('trazabilidad') }),
                "aria-current": isActive('trazabilidad') ? 'page' : undefined
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createElementVNode("svg", {
                    class: "icono",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M12 8v4l3 3" }),
                    _createElementVNode("path", { d: "M3.05 11a9 9 0 1 1 .5 4" }),
                    _createElementVNode("path", { d: "M3 4v4h4" })
                  ], -1),
                  _createElementVNode("span", null, "Trazabilidad", -1)
                ])),
                _: 1,
                __: [10]
              }, 8, ["class", "aria-current"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("a", {
        href: "#",
        onClick: _withModifiers(Logout, ["prevent"])
      }, _cache[12] || (_cache[12] = [
        _createElementVNode("svg", {
          class: "icono",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.8",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }),
          _createElementVNode("polyline", { points: "16 17 21 12 16 7" }),
          _createElementVNode("line", {
            x1: "21",
            y1: "12",
            x2: "9",
            y2: "12"
          })
        ], -1),
        _createElementVNode("span", null, "Salir", -1)
      ]))
    ])
  ]))
}
}

})